// @flow
import { COUNTRY_INFOS } from 'Client/cms/toolkit/constants';
import { LINE_COMMON_COUNTRY_INFOS } from 'Utils/request/requestDictionary';
import graphQLClient from 'Utils/graphql-client/graphqlClient';

export const countryInfosResolver = {
  name: COUNTRY_INFOS,
  resolve(appContext: AppContext, props: { countryId: string, isForFamily: boolean } = {}) {
    const { countryId, isForFamily } = props;
    const countryArgs = `countryId:"${countryId}" isForFamily:${isForFamily.toString()}`;

    const query = `query {
      config {
        common { close }
      }
      countryInfos(${countryArgs}) {
        texts {
          title
          description
          media {
            mediaUrl
            mediaAlt
          }
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_COUNTRY_INFOS,
      strictErrors: false,
    });
  },
};
